import React, { useState } from 'react';

const INK    = '#2B2620';
const WALNUT = '#8B4513';
const STONE  = '#8C8275';
const PAPER  = '#FDFBF8';
const FONT_SANS = "'IBM Plex Sans', -apple-system, BlinkMacSystemFont, 'Segoe UI', sans-serif";

const inputStyle = {
  width: '100%',
  padding: '10px 12px',
  border: '1px solid rgba(139,69,19,0.2)',
  borderRadius: '8px',
  fontSize: '14px',
  fontFamily: FONT_SANS,
  outline: 'none',
  background: PAPER
};

export default function InstallCapacity() {
  const [dailyCapacity, setDailyCapacity] = useState(2);
  const [crewCount, setCrewCount] = useState(2);
  const [averageJobDuration, setAverageJobDuration] = useState(1.5);

  const weeklyCapacity = dailyCapacity * 5; // Mon-Fri
  const monthlyCapacity = weeklyCapacity * 4;

  return (
    <div style={{ fontFamily: FONT_SANS }}>
      <h3 style={{
        fontSize: '15px',
        fontWeight: '600',
        color: INK,
        marginBottom: '16px'
      }}>
        Installation Capacity
      </h3>

      <div style={{
        padding: '20px',
        background: PAPER,
        borderRadius: '12px',
        border: '1px solid rgba(139,69,19,0.1)'
      }}>
        {/* Crew Count */}
        <div style={{ marginBottom: '20px' }}>
          <label style={{
            display: 'block',
            fontSize: '13px',
            fontWeight: '600',
            color: INK,
            marginBottom: '8px'
          }}>
            Active Installation Crews
          </label>
          <input
            type="number"
            min="1"
            max="10"
            value={crewCount}
            onChange={(e) => setCrewCount(parseInt(e.target.value) || 1)}
            style={inputStyle}
            onFocus={(e) => e.target.style.borderColor = WALNUT}
            onBlur={(e) => e.target.style.borderColor = 'rgba(139,69,19,0.2)'}
          />
          <div style={{
            fontSize: '12px',
            color: STONE,
            marginTop: '4px'
          }}>
            Number of installation teams available
          </div>
        </div>

        {/* Daily Capacity */}
        <div style={{ marginBottom: '20px' }}>
          <label style={{
            display: 'block',
            fontSize: '13px',
            fontWeight: '600',
            color: INK,
            marginBottom: '8px'
          }}>
            Daily Job Capacity
          </label>
          <input
            type="number"
            min="1"
            max="20"
            value={dailyCapacity}
            onChange={(e) => setDailyCapacity(parseInt(e.target.value) || 1)}
            style={inputStyle}
            onFocus={(e) => e.target.style.borderColor = WALNUT}
            onBlur={(e) => e.target.style.borderColor = 'rgba(139,69,19,0.2)'}
          />
          <div style={{
            fontSize: '12px',
            color: STONE,
            marginTop: '4px'
          }}>
            Maximum jobs that can be scheduled per day
          </div>
        </div>

        {/* Average Job Duration */}
        <div style={{ marginBottom: '24px' }}>
          <label style={{
            display: 'block',
            fontSize: '13px',
            fontWeight: '600',
            color: INK,
            marginBottom: '8px'
          }}>
            Average Job Duration (days)
          </label>
          <input
            type="number"
            min="0.5"
            max="10"
            step="0.5"
            value={averageJobDuration}
            onChange={(e) => setAverageJobDuration(parseFloat(e.target.value) || 1)}
            style={inputStyle}
            onFocus={(e) => e.target.style.borderColor = WALNUT}
            onBlur={(e) => e.target.style.borderColor = 'rgba(139,69,19,0.2)'}
          />
          <div style={{
            fontSize: '12px',
            color: STONE,
            marginTop: '4px'
          }}>
            Typical installation duration in workdays
          </div>
        </div>

        {/* Capacity Summary */}
        <div style={{
          padding: '16px',
          background: 'rgba(139,69,19,0.05)',
          borderRadius: '8px',
          border: '1px solid rgba(139,69,19,0.2)'
        }}>
          <div style={{
            fontSize: '13px',
            fontWeight: '600',
            color: WALNUT,
            marginBottom: '12px'
          }}>
            Capacity Summary
          </div>

          <div style={{
            display: 'grid',
            gap: '8px'
          }}>
            <CapacityRow label="Crews Available" value={`${crewCount} teams`} />
            <CapacityRow label="Daily Capacity" value={`${dailyCapacity} jobs/day`} />
            <CapacityRow label="Weekly Capacity" value={`${weeklyCapacity} jobs/week`} />
            <CapacityRow label="Monthly Capacity" value={`~${monthlyCapacity} jobs/month`} />
            <CapacityRow label="Avg Duration" value={`${averageJobDuration} days/job`} />
          </div>
        </div>

        {/* Save Button */}
        <button
          style={{
            marginTop: '20px',
            width: '100%',
            padding: '12px',
            background: WALNUT,
            border: 'none',
            borderRadius: '8px',
            fontSize: '14px',
            fontWeight: '600',
            fontFamily: FONT_SANS,
            color: 'white',
            cursor: 'pointer',
            transition: 'background 0.2s'
          }}
          onMouseEnter={(e) => e.currentTarget.style.background = '#A0522D'}
          onMouseLeave={(e) => e.currentTarget.style.background = WALNUT}
        >
          Save Capacity Settings
        </button>
      </div>
    </div>
  );
}

function CapacityRow({ label, value }) {
  return (
    <div style={{
      display: 'flex',
      justifyContent: 'space-between',
      fontSize: '12px'
    }}>
      <span style={{ color: STONE }}>{label}</span>
      <span style={{ fontWeight: '600', color: INK }}>{value}</span>
    </div>
  );
}
